import type { Address } from '@simplisafe/eis-commercetools-carts'

export const formatAddress = (a: Address): string => {
  const part1 = `${a.firstName} ${a.lastName}, ${a.streetName}`
  const part2 = a.additionalStreetInfo ? `, ${a.additionalStreetInfo}` : ''
  const part3 = `, ${a.city}, ${a.state} ${a.postalCode}`

  return `${part1}${part2}${part3}`.replace(/undefined/g, '')
}
